<template>
    <div class="loading-indicator">
        <div class="spinner">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
        <span>Loading...</span>
    </div>
</template>

<script>

export default {
    data() {
        return {}
    },
}
</script>
